import { useQuery } from '@tanstack/react-query'

import { orderService } from '@/services'

export const useOrderQuery = ({ orderNumber }) => {
  const { data, isPending } = useQuery({
    queryKey: ['order', orderNumber],
    queryFn: async () =>
      orderService.getOrder({
        orderNumber,
      }),
  })

  return {
    data,
    isLoadingOrder: isPending,
  }
}
